import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { FiEye, FiInfo } from "react-icons/fi";
import { FaCheck, FaTimes } from "react-icons/fa";
import toastr from "toastr";

import { ACTIVE_MODULE } from "app/_constants/constant";

import { getTrainingManagementStatusClass, TM_STATUS, TRAINING_TYPE } from "../CONSTANTS";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import Decline from "../../IncidentManagement/DeclinePopup";
import ConfirmAlert from "app/Components/CommanComponents/ConfirmAlert";
import {
  TRAINING_STATUS,
  TRAINEE_TYPE,
  trainingStatusFilterFields,
  TRAINING_TYPE_VIEW,
  trainingbatchFilterFields,
} from "../CONSTANTS";
import {
  getAllTrainingAssigners,
  updateAssignersStatus,
} from "app/_services/ehs/ehsTrainingServices";
import { isUserMM, isUserSO, isUserVTO } from "../../IncidentManagement/Helper";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import CommentPopup from "../../IncidentManagement/CommentPopup";
import { BsFillInfoCircleFill } from "react-icons/bs";
import TrainingBatchTab from "../Assign/Component/TrainingBatchTab";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import TrainingStatusFilters from "../Assign/Component/TrainingStatusFilters";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import TrainingBatchFilters from "../Assign/Component/TrainingBatchFilters";
import { capitalize } from "lodash";
import { capitalizeName } from "app/_helpers/helper";

const MyApprovalActions = () => {
  const [tab, setTab] = useState(isUserVTO() ? 1 : isUserSO() ? 2 : 3);
  const [trainings, setTrainings] = useState({
    minesManager: [],
    safetyOfficer: [],
    vocationalTrainingOfficer: [],
  });

  const [allTrainings, setAllTrainings] = useState([]);
  const [tableVFLList, setTableVFLList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showFilterBtn, setShowFilterBtn] = useState(true);
  const [filterForm, setFilterForm] = useState({});

  const onReset = () => setFilterForm({ batchName: "", traineeDesignation: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "traineeTypeView") {
        prev.traineeId = "";
      }
      return { ...prev, [name]: value };
    });
  };

  useEffect(() => {
    setShowFilterBtn(true);
  }, [tab]);

  const getData = useCallback(async () => {
    const response = await getAllTrainingAssigners();

    if (response?.data) {
      setAllTrainings(response?.data);
      setTrainings({
        // vocationalTrainingOfficer: response.data.filter((row) => row.trainingStatus === TRAINING_STATUS.scheduled),
        safetyOfficer: response.data.filter(
          (row) => row.trainingStatus === TRAINING_STATUS.soReview
        ),
        minesManager: response.data.filter(
          (row) => row.trainingStatus === TRAINING_STATUS.mmReview
        ),
      });
    }
    return response;
  }, []);

  const onSubmitApproveReject = useCallback(
    async (obj, extraObj) => {
      const result = await updateAssignersStatus(obj);

      if (result?.status) {
        toastr.success(result?.message || "Success");

        getData();
      }
      getData();
    },
    [getData]
  );

  const [sort, setSort] = useState({ order: "asc", dataField: "" });

  const tableContainerRef = useRef(null);

  const onTableChange = (actionType, { sortField: dataField, sortOrder: order }) => {
    if (actionType !== "sort") return;

    setSort({ dataField, order });
    setTableVFLList((prev) => {
      const newRows = [...prev].sort((a, b) => {
        if (order === "asc") return a[dataField] > b[dataField] ? -1 : 1;
        else return a[dataField] < b[dataField] ? -1 : 1;
      });

      return newRows;
    });
  };

  // ******** useMemo ******
  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "traineeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "traineeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "traineeName",
        text: "Name",
        sort: true,
        formatter: (status, row) => {
          return <div>{capitalizeName(row?.traineeName)}</div>;
        },
      },
      {
        dataField: "traineeDesignation",
        text: "Designation",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      {
        dataField: "trainingTypeView",
        text: "Training Type",
        sort: true,
        // formatter: (trainingTypeView) => {
        //   return TRAINING_TYPE_VIEW[trainingTypeView];
        // }
      },
      {
        dataField: "trainingCategoryName",
        text: "Skill Category",
        sort: true,
      },
      // {
      //   dataField: "trainingSubCategoryName",
      //   text: "Training Sub-Category",
      //   sort: true,
      // },

      {
        dataField: "startDate",
        text: "Start Date",
        sort: true,
        formatter: (startDate) => {
          return DDMMYYYYFormat(startDate);
        },
      },
      {
        dataField: "batchName",
        text: "Batch ID",
        sort: true,
      },
      {
        dataField: "trainingStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return <div className={getTrainingManagementStatusClass(status)}>{status}</div>;
        },
      },
      {
        dataField: "certificateId",
        text: "Certificate",
        sort: true,
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              {row?.trainingStatus === TRAINING_STATUS.completed && isUserVTO() ? (
                <CustomTooltip tooltip={"Certificate"}>
                  <a
                    href={
                      "/health-safety-and-environment/training-management/certificate/" +
                      row?.id
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icons text-cyanBlue"
                  >
                    <FiInfo style={{ color: "rgb(21 239 21)" }} />
                  </a>
                </CustomTooltip>
              ) : (
                "In Progress"
              )}
            </div>
          );
        },
      },
      {
        dataField: "ID",
        text: "Action",
        sort: true,
        formatter: (cell, row) => {
          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={`/health-safety-and-environment/training-management/view/${row.id}`}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>
              {row.trainingStatus === TRAINING_STATUS.scheduled && isUserVTO() && (
                <Decline
                  onSubmit={(obj) =>
                    onSubmitApproveReject({
                      ...obj,
                      assigneeIds: [row.id],
                      trainingStatus: TRAINING_STATUS.soReview,
                    })
                  }
                  title="Approve"
                  name={
                    <CustomTooltip tooltip="Approve">
                      <span className="pointer">
                        <FaCheck />
                      </span>
                    </CustomTooltip>
                  }
                  iconClass={"icons text-success"}
                />
              )}
              {row.trainingStatus === TRAINING_STATUS.soReview && isUserSO() && (
                <>
                  <Decline
                    onSubmit={(obj) =>
                      onSubmitApproveReject({
                        ...obj,
                        assigneeIds: [row.id],
                        trainingStatus:
                          row.trainingType === TRAINING_TYPE.other
                            ? TRAINING_STATUS.completed
                            : TRAINING_STATUS.mmReview,
                        trainingType: row.trainingType,
                      })
                    }
                    title="Approve"
                    name={
                      <CustomTooltip tooltip="Approve">
                        <span className="pointer">
                          <FaCheck />
                        </span>
                      </CustomTooltip>
                    }
                    iconClass={"icons text-success"}
                  />
                  <Decline
                    onSubmit={(obj) =>
                      onSubmitApproveReject({
                        ...obj,
                        assigneeIds: [row.id],
                        trainingStatus: row?.trainingStatus,
                        isBack: 1,
                      })
                    }
                    title="Reject"
                    name={
                      <CustomTooltip tooltip="Reject">
                        <span className="pointer">
                          <FaTimes />
                        </span>
                      </CustomTooltip>
                    }
                    iconClass={"icons text-danger"}
                  />
                </>
              )}
              {row.trainingStatus === TRAINING_STATUS.mmReview && isUserMM() && (
                <>
                  <Decline
                    onSubmit={(obj) =>
                      onSubmitApproveReject({
                        ...obj,
                        assigneeIds: [row.id],
                        trainingStatus: TRAINING_STATUS.completed,
                      })
                    }
                    title="Approve"
                    name={
                      <CustomTooltip tooltip="Approve">
                        <span className="pointer">
                          <FaCheck />
                        </span>
                      </CustomTooltip>
                    }
                    iconClass={"icons text-success"}
                  />

                  <Decline
                    onSubmit={(obj) =>
                      onSubmitApproveReject({
                        ...obj,
                        assigneeIds: [row.id],
                        trainingStatus: row?.trainingStatus,
                        isBack: 1,
                      })
                    }
                    title="Reject"
                    name={
                      <CustomTooltip tooltip="Reject">
                        <span className="pointer">
                          <FaTimes />
                        </span>
                      </CustomTooltip>
                    }
                    iconClass={"icons text-danger"}
                  />
                </>
              )}

              {row?.incidentReviewsData?.length !== 0 && (
                <CommentPopup
                  comments={row?.incidentReviewsData}
                  title="Comments"
                  name={
                    <CustomTooltip tooltip="Comments">
                      <BsFillInfoCircleFill />
                    </CustomTooltip>
                  }
                  iconClass={"icons text-default"}
                />
              )}
            </div>
          );
        },
      },
    ];

    return column;
  }, [onSubmitApproveReject]);

  useEffect(() => {
    getData();
  }, [getData]);

  // useEffect(() => {
  //   setTableVFLList(
  //     trainings[tab === 2 ? "safetyOfficer" : "minesManager"]
  //       .filter((d) => (filter.traineeType === "all" || d.traineeType === filter.traineeType) && (!filter.status || d.trainingStatus === filter.status))
  //       .map((row, index) => ({ ...row, sid: index + 1 }))
  //   );
  // }, [filter.traineeType, trainings, tab, filter.status]);

  useEffect(() => {
    setTableVFLList(
      trainings[tab === 2 ? "safetyOfficer" : "minesManager"]?.filter?.((data) => {
        let flag = true;
        if (filterForm?.traineeTypeView === "All") flag = true;

        if (flag) {
          for (const key in filterForm) {
            if (
              (key === "traineeTypeView" && filterForm?.traineeTypeView === "All") ||
              !filterForm[key]
            )
              continue;
            if (
              key !== "traineeDesignation" &&
              key !== "batchName" &&
              data[key] !== filterForm[key]
            )
              return (flag = false);
            else if (
              (key === "traineeDesignation" || key === "batchName") &&
              !data[key]?.toLowerCase()?.includes(filterForm[key]?.toLowerCase())
            )
              return (flag = false);
          }

          return (flag = true);
        }
        // if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, tab, trainings]);

  const updateTab = (n) => {
    setTableVFLList([]);
    setTab(n);
  };

  const tableToolbarBeforeView = () =>
    tab !== 1 &&
    showFilter && (
      <TrainingStatusFilters
        fields={trainingStatusFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "My Approval Actions" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="healthSafetyEnvironmentWrapper">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
            {isUserVTO() && (
              <a
                className={`${tab === 1 ? "active" : ""}`}
                href
                onClick={() => updateTab(1)}
              >
                Vocational Training Officer
              </a>
            )}
            {isUserSO() && (
              <a
                className={`${tab === 2 ? "active" : ""}`}
                href
                onClick={() => updateTab(2)}
              >
                Safety Officer
              </a>
            )}
            {isUserMM() && (
              <a
                className={`${tab === 3 ? "active" : ""}`}
                href
                onClick={() => updateTab(3)}
              >
                Mines Manager
              </a>
            )}
          </div>
        </div>
        <div className="p-2">
          <div className="card p-3 mt-3" ref={tableContainerRef}>
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">My Approval Actions</h3>
              {showFilterBtn && <FilterBtn setShowFilter={setShowFilter} />}
              <BackBtn url="/health-safety-and-environment/training-management" />
            </div>

            {tab === 1 ? (
              <TrainingBatchTab
                trainings={allTrainings}
                trainingInitialData={getData}
                editRow
                showFilter={showFilter}
                setShowFilterBtn={setShowFilterBtn}
              />
            ) : (
              <>
                <SearchBootstrapTable
                  searchKey={"myApprovalActionDesktopSearch"}
                  data={tableVFLList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                  columns={sortableColumn}
                  onTableChange={onTableChange}
                  sort={sort}
                  remote={{
                    sort: true,
                  }}
                  tableBeforeSearch={tableToolbarBeforeView}
                  tableKey="myApprovalAction"
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MyApprovalActions;
